import { Navigate, Outlet } from 'react-router-dom'
import { CALENDAR_SHIFT_ROUTE, HOME_ROUTE } from '../../../app/router/routes'
import { useAppSelector } from '../../../app/store/store'
import { canViewShiftSection } from '../../../entities/my'
import { LayoutPages } from '../../layoutPages'
import classes from './calendarShiftLayout.module.scss'

export default function CalendarShiftLayoutPage() {

    const {my} = useAppSelector(s => s.myReducer)

    if(!canViewShiftSection(my)){
        return <Navigate to={HOME_ROUTE.path} replace />
    }

    return (
        <LayoutPages title={CALENDAR_SHIFT_ROUTE.name}>
            <section className={classes.shiftPage}>
                <section className={classes.heading}>
                    <h1 className={classes.title}>Календарь смен</h1>
                    <p className={classes.subtitle}>
                        Управление сменами координаторов и кураторов.
                    </p>
                </section>

                <Outlet />
            </section>
        </LayoutPages>
    )
}
